import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../feature/payment/paymentSlice";

const PaymentModals = () => {
  const dispatch = useDispatch();
  const { isViewModalOpen, isDeleteModalOpen, viewSinglePayment } = useSelector(
    (state) => state.payments
  );

  const ViewPaymentModal = () => {
    return (
      <Dialog open={isViewModalOpen} onClose={() => dispatch(closeModal())}>
        <DialogTitle> {viewSinglePayment.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Title: {viewSinglePayment.title}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Slug: {viewSinglePayment.slug}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteConfirmationModal = () => {
    return (
      <Dialog open={isDeleteModalOpen}>
        <DialogTitle>Delete {viewSinglePayment.user} </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='error'>Delete</Button>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <ViewPaymentModal />
      <DeleteConfirmationModal />
    </>
  );
};

export default PaymentModals;
